import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface LoginState {
    accountExist: boolean;
    catalogs: Record<string, any>[];
}

const initialState: LoginState = {
    accountExist: false,
    catalogs: []
};

const serviceNowSlice = createSlice({
    name: "serviceNowDetails",
    initialState,
    reducers: {
        updateAccountExist: (state: LoginState, action: PayloadAction<{ value: boolean }>) => {
            state.accountExist = action.payload.value;
        },
        updateCatalogs: (state: LoginState, action: PayloadAction<{ value: Record<string, any>[] }>) => {
            state.catalogs = action.payload.value;
        }
    },
});

export const { updateAccountExist, updateCatalogs } = serviceNowSlice.actions;
export default serviceNowSlice.reducer;
